<template> 
    <div class="app-inner" id="AppAuthDetaii">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            </div>
            <div class="edit-from">
         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
          <div class="p-tit-c">
            <div class="businessDetail-info flex align-cen">
                 <div class="list">
                    应用官网分类：{{$util.offType(infoList.officialType)}}
                </div>
                 <div class="list">
                    授权应用：{{infoList.appName}}
                </div>
                 <div class="list">
                    使用企业：{{infoList.businessName}}
                </div>
                 <div class="list">
                    服务时间：{{infoList.type == 0 ? '无限制': (infoList.startTime || '无限制') + '-' + (infoList.endTime || '无限制')}}
                </div>
            </div>
          </div>
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  记录历史
            </div>
        </div>
          <div class="businessDetail-data-table">
               <el-table
            :data="infoList.platformAppAuthorityOperateList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column
            prop="operator"
            label="操作者"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="operateTime"
            label="操作时间"
           align="center"
             >
            </el-table-column>
             <el-table-column
            prop="action"
            label="操作行为"
           align="center"
           width="600"
             >
            </el-table-column>
               </el-table></div>
            </div>
    </div>
</template>
<script>
import { appAuthfun} from "@/api/index/index"  //获取授权详情
export default {
    name:'AppAuthDetaii',
    data() {
        return {
            infoList:{

            },
        }
    },
    created() {
        this.getDetail()
    },
    methods: {
        // 获取详情
        getDetail(){
               appAuthfun({
                id:this.$route.query.id
              },'get')
            .then(res => {
                console.log(res.data)
                this.infoList = res.data
            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
            this.$router.push('/AppAuth')
        },
    },
}
</script>
<style lang="scss" scoped>
.edit-from{
    margin-bottom: 44px;
    .p-tit-c{
        margin: 20px 0;
    }
      .businessDetail-info{
        padding: 30px 20px 20px 20px; 
      .list{
                width: 33%;
              
            }
    }
    .businessDetail-data-table{
        margin-top: 20px;
    }
}
</style>